import { Link } from "react-router-dom";
import check from "../assets/images/icons/check.svg";
import videoConsole from "../assets/images/icons/Group 42.svg";
import { useTranslation } from "./Localization";
import RoomHeader from "./RoomHeader";
import { resolveTourPath, useTourMode } from "./TourMode";

type Props = {
  nextTo: string;
  taskKey: "bombing" | "figure";
  buttonClass?: string;
};

export default function WarFramePage({ nextTo, taskKey, buttonClass = "war-frame-next" }: Props) {
  const { room, t } = useTranslation();
  const { interactive } = useTourMode();
  const instruction = room("war")?.tasks[taskKey];
  return <main className="screen war-frame">
    <div className="war-frame-localized-copy">
      <RoomHeader roomId="war" />
      <p className="instruction">{instruction}</p>
    </div>
    <button className="war-bombing-visual" type="button" aria-label={instruction}><img src={videoConsole} alt="" /></button>
    <Link className={buttonClass} to={resolveTourPath(nextTo, 1, interactive)} aria-label={t("common.next")}><img src={check} alt="" /></Link>
  </main>;
}
